import { render, staticRenderFns } from "./FeedbackDetailModal.vue?vue&type=template&id=40ecc656&scoped=true"
import script from "./FeedbackDetailModal.vue?vue&type=script&lang=js"
export * from "./FeedbackDetailModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDetailModal.vue?vue&type=style&index=0&id=40ecc656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecc656",
  null
  
)

export default component.exports